<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column align="center" :label="getType(typ)">
        <el-table-column
          prop="rank"
          align="center"
          label="排名"
        >
          <template scope="scope">
            {{ scope.$index+1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="num"
          align="center"
          :label="title"
          :formatter="scientificFormat"
        />
        <el-table-column
          prop="uid"
          align="center"
          label="玩家UID"
        >
          <template slot-scope="scope">
            <a href="javascript:;" style="color: #0e6cff;text-decoration:underline;text-underline: #1c84c6;" @click="gotoreward(scope.row.uid)"> {{ scope.row.uid }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="country"
          align="center"
          label="国家"
        />
        <el-table-column
          prop="price"
          align="center"
          label="累计充值"
          :formatter="scientificFormat"
        />
        <el-table-column
          prop="online"
          align="center"
          label="在线时长"
          :formatter="scientificFormat"
        />
        <el-table-column
          prop="reg_time"
          align="center"
          label="注册日期"
        />
        <el-table-column
          prop="log_time"
          align="center"
          label="登录日期"
        />
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getGrantRankStat } from '@/api/statistics/user_remain'

export default {
  name: 'RankData',
  props: {
    send: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: () => ''
    },
    typ: {
      type: Number,
      default: () => 1
    }
  },
  data() {
    return {
      typeTitle: '发送',
      typeArr: {
        1: '金币',
        2: '体力',
        3: '钻石',
        4: '野兽币'
      },
      tableData: [],
      queryParams: {
        startDate: '',
        type: 1,
        level: 1
      }
    }
  },
  created() {

  },
  methods: {
    getType(type) {
      let title = '消耗'
      if (this.send) {
        title = '发放'
      }
      return this.typeArr[type] + title + '排行榜'
    },
    scientificFormat(row, col, value) {
      if (value === 0) {
        return 0
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    gotoreward(uid) {
      this.$router.push({ name: 'User', query: { uid: uid }})
    },
    refresh(date, channel) {
      this.queryParams.type = this.typ
      this.queryParams.level = channel
      this.queryParams.startDate = date
      getGrantRankStat(this.queryParams).then(res => {
        this.tableData = res.data
        console.log('data', this.tableData)
        if (this.typ === 65 && this.tableData.length > 0) {
          this.tableData.forEach((item, index) => {
            this.tableData[index].num = (item / 10000).toFixed(2)
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
